export default __webpack_public_path__ + "static/media/Haval-and-GMW.23c23926.png";